import React, { useState, useEffect, useRef } from "react";
import CollegePageContainer from "../Container/CollegePageContainer";
import { connect } from "react-redux";
import Modal from "../../Components/Modal/Modal";
import { API } from "../../API";
import { handleCollegeMultiDateBookings } from "../Bookings2/Helper";
import { teacherResponse, getValidStartDate, getTeacherProfileName, teacherStatus, handleLogErrorToSlack } from "../../Helper";
import Moment from "react-moment";
import moment from "moment";
import FormField from "../../Components/FormField/FormField";
import { CKEditor } from "ckeditor4-react";
import { notify } from "react-notify-toast"
import axios from "axios";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import "./SendLessonMaterials.css"
import Spinner from "../../Components/Spinner/Spinner";
const _ = require("lodash");

const SendLessonMaterials = (props) => {
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);
  // const [allTeachers, setAllTeachers] = useState([]);
  const [allLevels, setAllLevels] = useState({})
  const [sendMaterialPopup, setSendMaterialPopup] = useState(false)
  const [event, setEvent] = useState(undefined)
  const [level, setLevel] = useState(undefined)
  const [emailContents, setEmailContents] = useState("<p><strong>Instruction for Monday's, Tuesday's teacher:</strong></p><p >Type your message here</p><p><strong>Instruction for Wednesday's teacher:</strong></p><p >Type your message here</p>")
  const [fileList, setFileList] = useState(null);
  const [sendByLevel, setSendByLevel] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false)
  const [isLoaded, setIsLoaded] = useState(true)
  const [filter, setFilter] = useState("todo")
  const fileInputRef = useRef();

  useEffect(() => {
    setIsLoaded(false)
    API.getAllTeachersBrief()
      .then((res) => {
        getAllBookings(res.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  const openSendMaterialPopup = (event) => {
    const startDate = event.booking_date
    const endDate = event.end_booking_date
    const datesArray = Array.from(moment.range(startDate, endDate).by('day')).map(m => `${m.format('dddd')}'s`);
    // console.log("datesArray: ", datesArray)
    let strDate = datesArray.join(", ")
    setEmailContents(`<p><strong>Instruction for ${strDate} teacher:</strong></p><p >Type your message here</p>`)
    setSendMaterialPopup(true)
    if (event) {
      setEvent(event)
    }
  }

  const openMaterialPopupForBulkSend = (level) => {
    const { booking_items } = level
    const arrDate = booking_items.map(item => {
      if(item.splits_index?.length) {
        return item.booking_dates
      }
      else {
        return item.booking_date
      }
    })
    const dates = _.flatten(arrDate).sort()
    const datesArray = dates.map(date => `${moment(date).format('dddd')}'s`)
    let content = ""
    _.uniq(datesArray).forEach(dateStr => {
      content +=`<p><strong>Instruction for ${dateStr} teacher:</strong></p><p >Type your message here</p>`
    })
    setEmailContents(content)
    setSendMaterialPopup(true)
    if(level) {
      setLevel(level)
    }
  }

  const materialsSent = (event) => {
    return event.materials.find(material => material.receiver_id === event.teacher_id)
  }

  const closeSendMaterialPopup = () => {
    setSendMaterialPopup(false)
    setEvent(null)
    setLevel(null)
  }

  const sendMaterials = () => {
    /*if (!fileList) {
      notify.show("Please upload lesson material")
    } else */ if (!emailContents) {
      notify.show("Please enter email content")
    } /* else if(!files.length) {
      notify.show("Please upload lesson material")
    } */ else {
      setIsSendingEmail(true)
      if(!files.length) {
        return API.sendLessonMaterial(
          sendByLevel ? "LEVEL_IN_WEEK" : "BOOKING",
          props.user.role === "personnel" ? props.user.personnel_id : props.user.customer_id,
          "[No-reply]" + getSubject(),
          "<p>You have received the following instructions and attachments relating to your upcoming booking: </p><br />" +
          emailContents + "<p>Please log in to your ReadyTeacher account to reply to this message.</p>",
          [],
          sendByLevel ? undefined : event._id,
          sendByLevel ? undefined : [event.split_index],
          sendByLevel ? level.level : undefined,
          props.institution._id,
          sendByLevel ? level.booking_items : undefined
        ).then((res) => {
          setIsSendingEmail(false)
          setTimeout(() => { window.location.reload(false) }, 2000)
          closeSendMaterialPopup();
          notify.show("Lesson materials sent successfully")
        }).catch((err) => {
          setIsSendingEmail(false)
          notify.show(err.response.data.error || "Failed to send lesson material")
          console.log(err.response)
        })
      }
      
      const zip = require('jszip')();
      for (let file = 0; file < files.length; file++) {
        // Zip file with the file name.
        zip.file(files[file].name, files[file]);
      }
      zip.generateAsync({ type: "blob" }).then(zipFiles => {
        // console.log(zipFiles)
        // Upload zipped files to AWS
        API.uploadFileToS3({
          fileName: `${getSubject()} ${new Date().getTime()}`,
          fileType: "application/zip",
          _id: "materials",
        })
          .then((res) => {
            const returnData = res.data.data.returnData;
            const signedRequest = returnData.signedRequest;
            const url = returnData.url;
            const options = {
              headers: {
                "Content-Type": "application/zip",
              },
            };
            axios
              .put(signedRequest, zipFiles, options)
              .then((res2) => {
                const prefix = "https://platform-backend-files.s3.amazonaws.com/";
                const suffix = url.substring(prefix.length, url.length);
                const new_url = prefix + suffix;
                // console.log(new_url)
                // console.log(level)

                API.sendLessonMaterial(
                  sendByLevel ? "LEVEL_IN_WEEK" : "BOOKING",
                  props.user.role === "personnel" ? props.user.personnel_id : props.user.customer_id,
                  "[No-reply]" + getSubject(),
                  "<p>You have received the following instructions and attachments relating to your upcoming booking: </p><br />" +
                  emailContents + "<p>Please log in to your ReadyTeacher account to reply to this message.</p>",
                  [new_url],
                  sendByLevel ? undefined : event._id,
                  sendByLevel ? undefined : [event.split_index],
                  sendByLevel ? level.level : undefined,
                  props.institution._id,
                  sendByLevel ? level.booking_items : undefined
                ).then((res) => {
                  setIsSendingEmail(false)
                  setTimeout(() => { window.location.reload(false) }, 2000)
                  closeSendMaterialPopup();
                  notify.show("Lesson materials sent successfully")
                }).catch((err) => {
                  setIsSendingEmail(false)
                  notify.show(err.response.data.error || "Failed to send lesson material")
                  console.log(err.response)
                })
              }).catch((error1) => {
                handleLogErrorToSlack(error1, true)
                setIsSendingEmail(false)
                notify.show("Failed to generate material download link")
                console.log(error1);
              });
          })
          .catch((err) => {
            setIsSendingEmail(false)
            console.log(err);
          });
      });
    }
  }

  const getSubject = () => {
    let subject = props.institution.institution_name + " Lesson plan for your "
    if (event || level) {
      if (sendByLevel) {
        subject += level.level + " class"
      } else {
        if (event.multiple_date && event.booking_date !== event.end_booking_date) {
          subject += event.level + " class from " + moment(getValidStartDate(event)).format("DD-MM-YYYY")
            + " to " + moment(event.end_booking_date).format("DD-MM-YYYY")
        } else {
          subject += event.level + " class on " + moment(event.booking_date).format("DD-MM-YYYY")
        }
      }
    }
    return subject
  }

  const filterEvents = (events, filter) => {
    let filteredEvents = events;
    switch (filter) {
      case "todo":
        setFilter("todo")
        filteredEvents = events.filter(event => !materialsSent(event));
        break;
      case "sent":
        setFilter("sent")
        filteredEvents = events.filter(event => materialsSent(event));
        break;
      case "inProgress":
        setFilter("inProgress")
        const today = moment(new Date()).format("YYYY-MM-DD");
        filteredEvents = events.filter(event => {
          if (event.multiple_date && event.booking_date !== event.end_booking_date) {
            return getValidStartDate(event) <= today
          } else {
            return event.booking_date <= today
          }
        });
        break;
    }
    return filteredEvents
  }

  const getSessionAndTag = (classData) => {
    if (classData.session === 1 || classData.session === "1") {
      return "AM Session (" + classData.reference_name + ") "
    } else if (classData.session === 2 || classData.session === "2") {
      return "PM Session (" + classData.reference_name + ") "
    } else if (classData.session === 3 || classData.session === "3") {
      return "EVE Session (" + classData.reference_name + ") "
    } else if (classData.session === 4 || classData.session === "4") {
      return "All Day Session (" + classData.reference_name + ") "
    }
  }

  const tabs = [
    {
      text: "My Bookings",
      pathname: "/SendLessonMaterials",
      active: true,
    },
    {
      text: "Inbox",
      pathname: "/Inbox",
    },
  ]

  const getAllBookings = (teachers) => {
    API.getCampusBookingsByInstitutionID(props.institution._id)
      .then((result) => {
        // console.log(result.data)
        let list = handleCollegeMultiDateBookings(result.data);
        let bookings = []
        let levels = []
        if (list) {
          list.forEach((event) => {
            let newEvent = { ...event }
            if (
              event.teacher_id &&
              (
                event.teacher_response === teacherResponse.accepted ||
                (
                  event.teacher_status === teacherStatus.assigned && 
                  event.teacher_id
                )
              )
              && event.end_booking_date >= moment(new Date()).format("YYYY-MM-DD")
              && !event.cancelled_by_inst
            ) {
              newEvent.teacher = teachers.find((teacher) => teacher._id === event.teacher_id);
              bookings.push(newEvent);
              // console.log(event)
              if (event.multiple_date) {
                event.splits.forEach(split => {
                  const monday = getMonday(split.date_from)
                  // console.log(monday)
                  if (split.date_from >= moment(new Date()).format("YYYY-MM-DD")) {
                    const booking_item = { 
                      _id: event._id, 
                      splits_index: [event.split_index], 
                      booking_dates: Array.from(moment.range(event.booking_date, event.end_booking_date).by('day')).map(m => m.format('YYYY-MM-DD'))
                    }
                    const existingLevel = levels?.find(level => level.level === event.level && level.week === monday)
                    if (existingLevel) {
                      if (!materialsSent(newEvent)) {
                        existingLevel.all_sent = false
                      }
                      const existing_booking_item = existingLevel.booking_items?.find(item => item._id === event._id)
                      if (existingLevel.booking_items?.find(item => item._id === event._id)) {
                        if (existing_booking_item.splits_index.indexOf(event.split_index) === -1) {
                          existing_booking_item.splits_index.push(event.split_index)
                          existing_booking_item.end_booking_date = event.end_booking_date
                          existing_booking_item.booking_dates = [
                            ...existing_booking_item.booking_dates,
                            ...Array.from(moment.range(event.booking_date, event.end_booking_date).by('day')).map(m => m.format('YYYY-MM-DD'))
                          ]
                        }
                      } else {
                        existingLevel.booking_items.push(booking_item)
                      }
                    } else {
                      if (materialsSent(newEvent)) {
                        levels.push({
                          level: event.level,
                          week: monday,
                          booking_items: [booking_item],
                          all_sent: true
                        })
                      } else {
                        levels.push({
                          level: event.level,
                          week: monday,
                          booking_items: [booking_item],
                          all_sent: false
                        })
                      }
                    }
                  }
                })
              } else {
                const monday = getMonday(event.booking_date)
                const existingLevel = levels?.find(level => level.level === event.level && level.week === monday)
                if (existingLevel) {
                  existingLevel.booking_items.push({ 
                    _id: event._id, 
                    booking_date: event.booking_date
                  })
                  if (!materialsSent(newEvent)) {
                    existingLevel.all_sent = false
                  }
                } else {
                  if (materialsSent(newEvent)) {
                    levels.push({
                      level: event.level,
                      week: monday,
                      booking_items: [{ 
                        _id: event._id, 
                        booking_date: event.booking_date,
                        end_booking_date: event.end_booking_date 
                      }],
                      all_sent: true
                    })
                  } else {
                    levels.push({
                      level: event.level,
                      week: monday,
                      booking_items: [{ 
                        _id: event._id, 
                        booking_date: event.booking_date,
                        end_booking_date: event.end_booking_date 
                      }],
                      all_sent: false
                    })
                  }
                }
              }
            }
          })
        }
        setIsLoaded(true)
        setAllBookings(bookings)
        setFilteredBookings(filterEvents(bookings, "todo"))
        setAllLevels(levels)
        // console.log(levels)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getMonday = (date) => {
    const d = new Date(date)
    let day = d.getDay()
    let diff = d.getDate() - day + (day === 0 ? -6 : 1);  // adjust when day is sunday
    return new Date(d.setDate(diff)).toLocaleDateString('en-GB');
  }

  const uploadFile = (e) => {
    console.log('Files: ', e.target.files)
    setFileList(e.target.files)
  }

  const removeAttachment = (idx) => {
    files.splice(idx, 1)
    setFileList(files)
    fileInputRef.current.value = files;
  }

  const files = fileList ? [...fileList] : [];

  const editorToolbar = [
    {
      name: "basicstyles",
      groups: ["basicstyles"],
      items: ["Bold", "Italic", "Strike", "Underline", "-", "Cut", "Copy", "Paste", "Undo", "Redo"],
    },
    {
      name: "paragraph",
      groups: ["list"],
      items: ["NumberedList", "BulletedList"],
    },
    { name: "links", items: ["Link", "Unlink"] },
  ];

  const toggleButtonStyle = {fontSize: "14px", textTransform: "none", width: "200px", height: "30px",
    color: "#79cbca", border: "1px solid #79cbca", lineHeight: "normal", textAlign: "center"}

  return (
    <CollegePageContainer user={props.user} tabs={tabs} header="Send Lesson Materials">
      {isLoaded ? <div className="d-flex flex-row">
        <div className="col-2 mb-2 send-materials-event-filter">
          <div
            className={"p-3 " + (
              filter === "todo" ? "send-materials-event-filter-selected text-white" : "")}
            onClick={() => setFilteredBookings(filterEvents(allBookings, "todo"))}
          >
            To do
          </div>
          <div
            className={"p-3 " + (
              filter === "sent" ? "send-materials-event-filter-selected text-white" : "border-top border-bottom")}
            onClick={() => {
              setFilteredBookings(filterEvents(allBookings, "sent"))
              setSendByLevel(false)
            }}
          >
            Sent
          </div>
          <div
            className={"p-3 " + (
              filter === "inProgress" ? "send-materials-event-filter-selected text-white" : "")}
            onClick={() => {
              setFilteredBookings(filterEvents(allBookings, "inProgress"))
              setSendByLevel(false)
            }}
          >
            Bookings in progress
          </div>
        </div>
        <div className="col-10">
          <div className="d-flex justify-content-between">
            <h2 className='search-teacher-heading ml-1 mb-3'>
              My Bookings
            </h2>
            <ToggleButtonGroup
              exclusive
              onChange={() => setSendByLevel(!sendByLevel)}
              hidden={filter !== "todo" || filteredBookings.length === 0}
              className="mt-1 mr-1"
            >
              <ToggleButton
                style={toggleButtonStyle}
                className={!sendByLevel ? " btn-primary text-white" : " secondary-button-no-margin-hover"}
              >
                Send to Individuals
              </ToggleButton>
              <ToggleButton
                style={toggleButtonStyle}
                className={sendByLevel ? " btn-primary text-white" : " secondary-button-no-margin-hover"}
                value="institutionLogin">
                Bulk send by Class Level
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          {!sendByLevel && filteredBookings && filteredBookings.map((job) => {
            return <div
              className={"d-flex flex-row justify-content-between border my-3 py-3 pl-2 " + (
                materialsSent(job) ? "shadow-box-grey" : "shadow-box")}>
              <div className="col-9 h5 pt-1">
                <p className="d-inline-block">
                  <strong>{getTeacherProfileName(job.teacher)}</strong>{", "}
                </p>
                <strong>{job.level}</strong>{", "}
                {props.classes.find(c => c._id === job.class_id)
                  ? getSessionAndTag(props.classes.find(c => c._id === job.class_id))
                  : job?.class
                    ? getSessionAndTag(job.class)
                    : {}
                }
                {props.campuses.find(campus => campus._id === job.campus_id)
                  ? "at " + props.campuses.find(campus => campus._id === job.campus_id).reference_name + " "
                  : ""}
                {job.multiple_date &&
                job.booking_date !== job.end_booking_date ? (
                  <>
                    {" "}from{" "}
                    <strong>
                      <Moment format="DD-MM-YY">{getValidStartDate(job)}</Moment>
                    </strong>
                    {" "}to{" "}
                    <strong>
                      <Moment format="DD-MM-YY">{job.end_booking_date}</Moment>
                    </strong>
                  </>
                ) : (
                  <>
                    {" "}on{" "}
                    <strong>
                      <Moment format="DD-MM-YY">{job.booking_date}</Moment>
                    </strong>
                  </>
                )}
              </div>

              <div className="col-3 d-flex flex-row-reverse">
                <button
                  className={"btn h-auto my-auto px-3 " + (
                    materialsSent(job) ? "secondary-button-no-margin-hover" : "btn-primary")}
                  onClick={() => {
                    const material_id = materialsSent(job)?._id
                    material_id ? props.history.push("/Inbox#" + material_id) : openSendMaterialPopup(job)
                  }}
                >
                  {materialsSent(job) ? "View Materials / Send More" : "Create Message"}
                </button>
              </div>
            </div>
          })}

          {filter === "todo" && !sendByLevel && filteredBookings.length === 0 && <div className="center-text my-5 h5">
            Congratulations! All your lesson plans are up-to-date.
            </div>}

          {sendByLevel && allLevels && allLevels.map((level) => {
            return <div
              className={"d-flex flex-row justify-content-between border my-3 py-3 pl-2 " + (
                level.all_sent ? "shadow-box-grey" : "shadow-box")}>
              <div className="col-9 h5 pt-1">
                <strong>{level.level}</strong>{", "}
                <p className="d-inline-block">
                  Week starting <strong>{level.week}</strong>
                </p>
              </div>

              <div className="col-3 d-flex flex-row-reverse">
                <button
                  className={"h-auto my-auto px-3 btn " + (
                    level.all_sent ? "secondary-button-no-margin-hover" : "btn-primary")}
                  onClick={() => openMaterialPopupForBulkSend(level)}
                  disabled={level.all_sent}
                >
                  {level.all_sent ? "Materials Sent" : "Create Message"}
                </button>
              </div>
            </div>
          })}
        </div>
      </div>
        : <Spinner small />}

      <Modal
        className="w-50"
        header={!sendByLevel && event? "Send Materials to " + getTeacherProfileName(event.teacher) : "Send Materials" }
        onClose={closeSendMaterialPopup}
        show={sendMaterialPopup}
        enforceFocus={false}
      >
        <FormField
          label="Subject"
          id="email-subject"
          disabled
          placeholder={getSubject()}
        >
        </FormField>
        <label>Email Contents</label>
        <CKEditor
          config={{ toolbar: editorToolbar, removeButtons: 'Subscript, Superscript', versionCheck: false  }}
          onChange={({ editor }) => setEmailContents(editor.getData())}
          content={emailContents}
          style={{ boxShadow: "inset 0 0 0 1px #fff, 1px 1px 2px #1beabd, 1px 1px 8px #10afff" }}
          initData={emailContents}
        />
        <div className="form-row py-3">
          <div className="col-sm-auto pt-2">
            <button
              type="submit"
              className="btn btn-outline-secondary btn-block"
              onClick={() => document.getElementById("attachments").click()}
              disabled={fileList && fileList?.length > 0}
            >
              Attachments
              <i className="align-middle icon-paper-clip fa fa-paperclip ml-1" />
              <input
                id="attachments"
                type="file"
                onChange={(e) => uploadFile(e)}
                multiple
                className="d-none"
                ref={fileInputRef}
              />
            </button>
            <ul>
              {files.map((file, i) => (
                <div>
                  <li className="d-inline" key={i}>{file.name}</li>
                  <i
                    className="mdi mdi-delete-circle mt-1 ml-1 uploaded-file-delete-icon"
                    onClick={() => removeAttachment(i)}
                  />
                </div>
              ))}
            </ul>
          </div>
          <div className="col py-2">
            <button
              // type="submit"
              disabled={isSendingEmail}
              className="btn btn-primary float-right ml-1"
              onClick={sendMaterials}
            >
              Send Materials
            </button>
            <div className={isSendingEmail ? "text-right text-secondary pt-1 mr-2" : "d-none"}>Sending...</div>
          </div>
        </div>
      </Modal>
    </CollegePageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    classes: state.college.classes,
    campuses: state.college.campuses
  };
}

export default connect(mapStateToProps)(SendLessonMaterials);